import '../IdcGlobal.IBP.Web/theme/US/site_1/css/owl.carousel.min.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/owl.theme.default.min.css'
import '../IdcGlobal.IBP.Web/js/owl.carousel.js'